import { Button, ButtonGroup, HStack, Select, Text } from '@chakra-ui/react'

type DataTablePaginationProps = {
  pageIndex: number
  pageSize: number
  pageCount: number
  totalCount: number
  isLoading?: boolean
  onPageChange: (pageIndex: number) => void
  onPageSizeChange: (pageSize: number) => void
}

export const DataTablePagination = ({
  pageIndex,
  pageSize,
  pageCount,
  totalCount,
  isLoading,
  onPageChange,
  onPageSizeChange,
}: DataTablePaginationProps) => {
  const start = totalCount === 0 ? 0 : pageIndex * pageSize + 1
  const end = Math.min((pageIndex + 1) * pageSize, totalCount)

  return (
    <HStack justify="space-between" mt={4} wrap="wrap" spacing={4}>
      <HStack spacing={3}>
        <Text fontSize="sm" color="presets.neutral.70">
          {start}-{end} of {totalCount}
        </Text>
        <Select
          size="sm"
          width="96px"
          value={pageSize}
          onChange={event => onPageSizeChange(Number(event.target.value))}
        >
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </Select>
      </HStack>

      <ButtonGroup isAttached size="sm" variant="secondary">
        <Button
          onClick={() => onPageChange(pageIndex - 1)}
          isDisabled={pageIndex === 0 || isLoading}
        >
          Previous
        </Button>
        <Button isDisabled>
          Page {pageCount === 0 ? 0 : pageIndex + 1} of {Math.max(pageCount, 1)}
        </Button>
        <Button
          onClick={() => onPageChange(pageIndex + 1)}
          isDisabled={pageIndex + 1 >= pageCount || isLoading}
        >
          Next
        </Button>
      </ButtonGroup>
    </HStack>
  )
}
